import StyleVariables from "./styles";
import styled from '@emotion/styled'

const sv = StyleVariables;

export const BoxContainer = styled(`div`)`
  width: 100%;
  ${sv.flexCenter};
  @media(max-width: 850px) {
    margin-bottom: 20px;
  }
`;

export const Box = styled(`div`)`
  flex: 1;
  max-width: ${props => props.maxWidth ? props.maxWidth : '400px'};
  margin: 0 12px;
  padding: 36px;
  ${sv.box};
  min-height: ${props => props.minHeight ? props.minHeight : ''};
  background: ${sv.colors.light};
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,.3);
  color: ${sv.colors.dark};
  ${sv.flexColumn};
  align-items: center;
  p {
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
  }
`;

export const BoxTitle = styled(`div`)`
  ${sv.h2};
  margin-bottom: 20px;
`;